import DOMPurify, { type Config } from 'dompurify';

/**
 * Sanitiser config for SVG fetched from the backend storage proxy.
 *
 * Threat model: Trusstor profession admins (or anyone who can influence
 * the storage bucket) can upload arbitrary SVG. Without sanitisation an
 * SVG with `<script>` / `onload=` / `xlink:href="javascript:…"` becomes
 * stored XSS in the d-orca origin via `dangerouslySetInnerHTML`.
 *
 * `USE_PROFILES.svg + svgFilters` strips every HTML-only construct;
 * `FORBID_TAGS`/`FORBID_ATTR` belt-and-braces the most-common
 * script-execution vectors. `ADD_ATTR` keeps `fill` / `stroke` so trade
 * pictograms still get their inline recolouring.
 */
const CONFIG: Config = {
  USE_PROFILES: { svg: true, svgFilters: true },
  ADD_ATTR: ['fill', 'stroke'],
  FORBID_TAGS: ['script', 'foreignObject'],
  FORBID_ATTR: ['onload', 'onerror', 'onmouseover', 'onclick', 'onfocus'],
};

/**
 * Sanitise an SVG string before passing it to `dangerouslySetInnerHTML`.
 * Returns an empty string when input is empty so consumers can short-
 * circuit on falsy.
 */
export function sanitizeSvg(input: string): string {
  if (!input) return '';
  return DOMPurify.sanitize(input, CONFIG) as unknown as string;
}
